import React, { useState, useEffect } from 'react'
import { getCurrentUser } from './services/auth'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'

export default function App() {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getCurrentUser().then(u => {
      setUser(u)
      setLoading(false)
    })
  }, [])

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: '#e8e4dc',
        fontFamily: "'Segoe UI', sans-serif", fontSize: 16, color: '#888'
      }}>
        Loading...
      </div>
    )
  }

  if (!user) return <Login onLogin={() => getCurrentUser().then(setUser)} />
  return <Dashboard user={user} onLogout={() => setUser(null)} />
}